import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-533b6050"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "references-detail-pane iodine-no-scroll-y full-height text-center flex-grow-1 flex-shrink-0" }
const _hoisted_2 = { class: "reference-content-container iodine-padding-lg" }

import ReferencesDetailTitle from 'components/references/ReferencesDetailTitle.vue';
import ReferencesDetailToolbar from 'components/references/ReferencesDetailToolbar.vue';
import ReferencesContent from 'components/references/ReferencesContent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesDetail',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReferencesDetailTitle),
    _createVNode(ReferencesDetailToolbar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ReferencesContent, { content: "MockArticle.content" })
    ])
  ]))
}
}

})